import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { Box } from "@chakra-ui/react";

export const NotFound = () => {
  return (
    <main>
      {/* SEO */}
      <Helmet>
        <title>404 | Felco ThemeGen</title>
        <meta name="title" content="404 | Felco ThemeGen"></meta>
        <meta
          name="description"
          content="Generate Themes And Export, Theme Generator"
        />
        <meta
          name="keywords"
          content="ThemeGen, Themeit, Theme Generator, Generate Themes, theme.js, 404, page not found, page-not-found"
        />
        <link rel="canonical" href="https://themegen.netlify.app/404" />

        {/* Open Graph / Facebook  */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://themegen.netlify.app/404" />
        <meta property="og:title" content="404 | Felco ThemeGen" />
        <meta
          property="og:description"
          content="Generate Themes And Export, Theme Generator"
        />
        {/* <meta property="og:image" content="" /> */}

        {/* Twitter  */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://themegen.netlify.app/404"
        />
        <meta property="twitter:title" content="404 | Felco ThemeGen" />
        <meta
          property="twitter:description"
          content="Generate Themes And Export, Theme Generator"
        />
        {/* <meta property="twitter:image" content="" /> */}

        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6991856412998100"
     crossorigin="anonymous"></script>
      </Helmet>
      404 not Found
      <Box fontSize="36px" fontWeight="bold">
        <Link to="/">Return to HomePage</Link>
      </Box>
    </main>
  );
};
